/**
 * Development mode detection
 * Checks for various development indicators
 */
export const isDevelopmentMode = () => {
	return (
		// Check for localhost
		window.location.hostname === 'localhost' ||
		window.location.hostname === '127.0.0.1' ||
		// Check for development cookie
		document.cookie.includes('tailwind_debug=true')
	)
}

/**
 * Development logger - only logs in development mode
 */
export const debugLog = {
	log: (...args) => isDevelopmentMode() && console.log('TAILWIND LOG:', ...args),
	info: (...args) => isDevelopmentMode() && console.info('TAILWIND INFO:', ...args),
	warn: (...args) => isDevelopmentMode() && console.warn('TAILWIND WARN:', ...args),
	error: (...args) => isDevelopmentMode() && console.error('TAILWIND ERROR:', ...args),
	success: (...args) => isDevelopmentMode() && console.log('TAILWIND SUCCESS:', ...args),
}
